(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1385],{

/***/ 68752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var IncludedFee = function IncludedFee(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "row mb-4 justify-between last:mb-0 lg:mb-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "col-12 self-center lg:col-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "h2",
            className: "bbc-title mb-4 text-center font-semibold text-bbc-brand-800 lg:mb-8 lg:text-left",
            text: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
            className: "mx-4 mb-6 list-disc leading-bbc-26 lg:mx-0 lg:mb-0 ",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
                className: "  relative mb-2 list-none pl-5  text-bbc-gray before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-[5px] before:w-[5px] before:rounded-full before:bg-bbc-gray before:content-['']",
                children: content
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "col-12 text-center lg:col-6 ".concat(item.positionImage === "left" ? "lg:order-first lg:text-left" : "order-last lg:text-right"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, item.img))
        })]
      }, index);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IncludedFee);
IncludedFee.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var OnlineBankingTool = function OnlineBankingTool(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "row justify-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "row col-12 rounded-3xl bg-bbc-gradient-9 py-6 lg:col-10 lg:py-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: "col-12 order-1 self-center pr-0 lg:col-5 lg:order-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              text: data.title,
              as: "h5",
              className: "mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "mb-6 text-base font-normal text-white",
              children: data.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                target: "_blank",
                className: "rounded-[50px] border px-4 py-1 text-white ",
                href: "#",
                children: "Try Now"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "col-12 order-0 text-center lg:col-7 lg:order-1 lg:text-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
              src: data.image,
              alt: "online baking tool"
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OnlineBankingTool);
OnlineBankingTool.defaultProps = {
  className: ""
};

/***/ }),

/***/ 19367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_priceConvert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46518);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_IncludedFee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68752);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35831);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var CardBankFee = function CardBankFee(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: "shadow-bbc flex h-full flex-col justify-between rounded-3xl bg-white py-10 px-7 text-center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
      className: "mb-10 text-2xl font-semibold leading-9 text-bbc-brand-700 ",
      children: data.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
      className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fee)),
      children: [(0,common_priceConvert__WEBPACK_IMPORTED_MODULE_0__/* .AutoConvertPriceWithUnit */ .Nd)(data.fee, 1), data.haveNote && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        children: "*"
      })]
    }), data.note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
      className: "mt-10 grow",
      dangerouslySetInnerHTML: {
        __html: (0,common_priceConvert__WEBPACK_IMPORTED_MODULE_0__/* .convertPriceOnString */ .eY)(data.note)
      }
    })]
  });
};

var OpenBankAccount = function OpenBankAccount(_ref2) {
  var _data$bank_fee, _data$bank_fee2;

  var data = _ref2.data,
      country = _ref2.country,
      title = _ref2.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    id: "banking_options",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          className: "bbc-title mb-6 text-center capitalize",
          text: title ? title : "Open a Bank Account for ".concat(country, " Company ")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "m-auto w-5/6 text-center",
          dangerouslySetInnerHTML: {
            __html: data.note || "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply."
          }
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "relative overflow-hidden pt-10 pb-10 lg:pb-20",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container relative z-20",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "row justify-center",
          children: ((_data$bank_fee = data.bank_fee) === null || _data$bank_fee === void 0 ? void 0 : _data$bank_fee.length) > 0 && ((_data$bank_fee2 = data.bank_fee) === null || _data$bank_fee2 === void 0 ? void 0 : _data$bank_fee2.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "col-12 mt-6 first:mt-0 md:col-6 md:mt-0 lg:col-5 xl:col-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(CardBankFee, {
                data: item
              })
            }, index);
          }))
        })
      }), data.noteBottom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "relative z-20 m-auto mt-6 w-5/6 text-center lg:mt-10",
          dangerouslySetInnerHTML: {
            __html: data.noteBottom || "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply."
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/wave/top_bg-wave.png",
        width: 1920,
        height: 125,
        className: "w-full",
        wrapper: {
          className: "w-full absolute top-20 left-0 right-0 z-10 "
        },
        alt: "Wave top"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().waveTop))
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "pt-10:pt-20 bg-bbc-package",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_molecules_IncludedFee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          data: data.included
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: " absolute hidden h-1/2 w-full bg-bbc-package md:block"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/wave/bottom-wave.png",
        width: 1920,
        height: 140,
        className: "w-full",
        wrapper: {
          className: "absolute w-full top-1/2 md:block"
        },
        alt: "Wave bottom"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OpenBankAccount);

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 1059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var WalkThrough = function WalkThrough(_ref) {
  var data = _ref.data;
  var walkthrough = data.walkthrough;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      className: "bbc-title mb-6 text-center capitalize",
      text: data.title
    }), data.description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: "mb-6 lg:mb-10",
      children: data.description
    }), walkthrough.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "row mb-6 justify-between last:mb-0 lg:mb-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "".concat(item.classNameLeft ? item.classNameLeft : "col-12 self-center lg:col-6"),
          children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "".concat(item.classNameTitle ? "h3" : "h4"),
            className: "".concat(item.classNameTitle ? item.classNameTitle : "mb-4 text-left text-lg font-semibold lg:mb-6", "   "),
            text: item.title
          }), item.isList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
            className: "mx-0 list-disc pl-5 text-left",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
                className: "relative leading-[26px] text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: content
                }
              }, index);
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "mx-0 list-disc text-left ",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                className: "relative mb-6 list-none text-bbc-gray last:mb-0",
                dangerouslySetInnerHTML: {
                  __html: content
                }
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (item.classNameRight ? item.classNameRight : "col-12 order-first mb-6 text-center leading-none lg:col-5 lg:mb-0 ") + (item.positionImage === "left" ? " lg:order-first" : " lg:order-last lg:text-right"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, item.img))
        })]
      }, index);
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WalkThrough);
WalkThrough.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 25637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/** ========== */





var WhyChooseUs = function WhyChooseUs(_ref) {
  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      note = _ref.note,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("section", {
    className: sectionClassName,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        children: [note && note.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
            className: "mb-10 text-center text-white",
            dangerouslySetInnerHTML: {
              __html: note
            }
          })]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "title-h2 mb-4 text-center text-white lg:mb-10"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "row justify-center gap-y-6 lg:gap-y-10",
          children: data.length > 0 && data.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
              className: "col-12 ".concat(data.length === 4 ? "lg:col-3" : "lg:col-4"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                className: "text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                  src: item.icon.src,
                  alt: item.icon.altText,
                  width: 48,
                  height: 48,
                  wrapper: {
                    className: "flex items-center justify-center bg-white rounded-[26px] h-20 w-20  mx-auto"
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                  className: "flex justify-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    as: "h3",
                    text: item.title,
                    className: "mt-6 w-5/6 text-lg font-semibold normal-case text-white"
                  })
                }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                  className: "mt-3 !normal-case text-white",
                  children: item.description
                })]
              })
            }, index);
          })
        })]
      })
    }), children]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhyChooseUs);
WhyChooseUs.defaultProps = {
  title: "",
  data: [],
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 81385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1216);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31741);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37768);
/* harmony import */ var components_organisms_HowItWorks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78354);
/* harmony import */ var components_organisms_OnlineBankingTool__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80651);
/* harmony import */ var components_organisms_OpenBankAccount__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19367);
/* harmony import */ var components_organisms_RequiredDocument__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95183);
/* harmony import */ var components_organisms_Walkthrough__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1059);
/* harmony import */ var components_organisms_WhyChooseUs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);
















var NewsSlider = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/common/merchant-account-consulting/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var MerchantAccountConsultingTemplate = function MerchantAccountConsultingTemplate(_ref) {
  var _dataJson$dataWhyChoo, _dataJson$dataWhyChoo2, _dataJson$dataWhyChoo3, _dataJson$dataMakeItW, _dataJson$dataMakeItW2;

  var data = _ref.data,
      dataJson = _ref.dataJson;
  var country = dataJson.country,
      breadcrumbs = dataJson.breadcrumbs,
      dataHowToOpen = dataJson.dataHowToOpen,
      dataOpenBankFee = dataJson.dataOpenBankFee;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: breadcrumbs,
      title: dataJson.title,
      description: dataJson.description,
      titleProps: {
        className: "banner-default-title capitalize",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        wrapper: {
          className: "bbc-banner-image-bottom-0"
        },
        src: dataJson !== null && dataJson !== void 0 && dataJson.imgBanner ? dataJson === null || dataJson === void 0 ? void 0 : dataJson.imgBanner : "/assets/images/common/banner-merchant-account.png",
        className: "h-full w-full ",
        width: 572,
        height: 491,
        priority: true,
        alt: dataJson.alt
      }),
      bgColor: "bg-bbc-country"
    }), dataJson.fullWalkthrough && typeof dataJson.fullWalkthrough === "object" && Object.keys(dataJson.fullWalkthrough).length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_Walkthrough__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          data: dataJson.fullWalkthrough
        })
      })
    }), dataJson.dataHowToOpen && typeof dataJson.dataHowToOpen === "object" && Object.keys(dataJson.dataHowToOpen).length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          text: dataHowToOpen.title,
          className: "bbc-title mt-20 mb-10 text-center capitalize"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "paragraph ".concat(country.toLowerCase() === "singapore" && "blue-marker"),
          children: dataHowToOpen.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: item
              }
            }, index);
          })
        }), dataHowToOpen.note ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: dataHowToOpen.note
          }
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("p", {
            className: " mt-4 border-l-4 border-bbc-brand-700 pl-2 font-medium",
            children: ["Wonder which can be the best bank for your ", country, " ", "company? Let's find out with our", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              href: "/guide-and-tool/banking-tool",
              target: "_blank",
              className: "text-bbc-brand-500",
              children: "Banking Tool"
            })]
          })
        })]
      })
    }), dataJson.dataOnlineBankingTool && typeof dataJson.dataOnlineBankingTool === "object" && Object.keys(dataJson.dataOnlineBankingTool).length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_OnlineBankingTool__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        data: dataJson.dataOnlineBankingTool
      })
    }), dataOpenBankFee && Object.keys(dataOpenBankFee).length > 0 && dataOpenBankFee.bank_fee.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      className: "pb-10 lg:pb-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_OpenBankAccount__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        data: dataOpenBankFee,
        country: country,
        title: dataOpenBankFee.title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_WhyChooseUs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      title: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataWhyChoo = dataJson.dataWhyChooseUs) === null || _dataJson$dataWhyChoo === void 0 ? void 0 : _dataJson$dataWhyChoo.title,
      note: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataWhyChoo2 = dataJson.dataWhyChooseUs) === null || _dataJson$dataWhyChoo2 === void 0 ? void 0 : _dataJson$dataWhyChoo2.note,
      sectionClassName: "bg-bbc-gradient-3 py-10 lg:py-20",
      data: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataWhyChoo3 = dataJson.dataWhyChooseUs) === null || _dataJson$dataWhyChoo3 === void 0 ? void 0 : _dataJson$dataWhyChoo3.listIcons
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_HowItWorks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        data: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataMakeItW = dataJson.dataMakeItWork) === null || _dataJson$dataMakeItW === void 0 ? void 0 : _dataJson$dataMakeItW.contents,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          className: "text-center font-semibold capitalize lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
            className: "block text-3xl text-bbc-brand-800 lg:text-bbc-40px",
            dangerouslySetInnerHTML: {
              __html: dataJson === null || dataJson === void 0 ? void 0 : (_dataJson$dataMakeItW2 = dataJson.dataMakeItWork) === null || _dataJson$dataMakeItW2 === void 0 ? void 0 : _dataJson$dataMakeItW2.title
            }
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_RequiredDocument__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        title: dataJson.dataRequiredDocument.title || "Required Documents",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20",
        backgroundImage: "/assets/images/common/required-documents.png"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "lg:col-10 lg:m-auto",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            data: dataJson.dataFaqs,
            title: dataJson.dataFaqs.title,
            description: " ",
            defaultActiveKey: dataJson.dataFaqs.defaultActiveKey,
            multipleOpen: dataJson.dataFaqs.multipleOpen
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MerchantAccountConsultingTemplate);
MerchantAccountConsultingTemplate.defaultProps = {
  data: {},
  posts: []
};

/***/ }),

/***/ 73579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _loadable = _interopRequireDefault(__webpack_require__(23668));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);
  var suspenseOptions = loadableOptions;

  if (true) {
    // Error if react root is not enabled and `suspense` option is set to true
    if ( true && suspenseOptions.suspense) {
      // TODO: add error doc when this feature is stable
      throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
  }

  if (suspenseOptions.suspense) {
    return loadableFn(suspenseOptions);
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2553);

var _createClass = __webpack_require__(62012);

var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _useSubscription = __webpack_require__(67161);

var _loadableContext = __webpack_require__(3982);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }

  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function' && "function" === 'function' && !opts.suspense) {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  function LoadableImpl(props, ref) {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription).useSubscription(subscription);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    return _react["default"].createElement(opts.lazy, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return !opts.suspense && init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 35831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fee":"Index_fee__whWDJ","waveTop":"Index_waveTop__6hRwa"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

}]);